import React from 'react';

const DataListBody = (props) => {
	return (
		<div className={`data-list__body container-fluid p-0${props.className ? ' ' + props.className : ''}`}>
			{props.children}
		</div>
	)
};

export default DataListBody;